// extracted by mini-css-extract-plugin
module.exports = {"specification-table":"specification-table-09f86ec7022cbd38c9b734a857f20620","goods-table-div":"goods-table-div-54ddfcc38f65c52cc0e2e05714745711"};